export default "__VITE_ASSET__RrOLMmMK__"